// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import common from './common';
import user from './user';
import cmsContent from './cmsContent';
import email from './email';
import pipeline from './pipeline';
import chat from './chat';
import baseQueryApi from './api/baseQueryApi';
import chatApiNew from './api/chatApiNew';

const rootReducer = {
  navbar,
  layout,
  common,
  user,
  email,
  cmsContent,
  pipeline,
  chat,
  [baseQueryApi.reducerPath]: baseQueryApi.reducer,
  [chatApiNew.reducerPath]: chatApiNew.reducer,
};

export default rootReducer;
